module.exports = __webpack_public_path__ + "img/kernelback3.5cd55dac.png";